import { toJS } from 'mobx'
import { inject, observer } from 'mobx-react'
import React, { useCallback, useEffect, useState } from 'react'
import TableComponent from '../../../components/Common/TableComponent'
import { Empty, Pagination, Spin, Table } from 'antd'
import { TableBottomPaginationBlock } from '../../../components/Common/Table'
import moment from 'moment'
import './style.css'

const ExportDistributeVoteTable = props => {
  const { managementAssetWarehouseStore, isLoading, currentDate } = props

  const {
    assetStatisticList,
    pageIndex,
    sizeIndex,
    totalCount,
  } = managementAssetWarehouseStore

  useEffect(() => {
    ;(async () => {
      await managementAssetWarehouseStore.clearFilter()
    })()
  }, [])

  const handleChangePage = useCallback(
    p => {
      const pageIndex = p - 1
      managementAssetWarehouseStore.setFilter('pageIndex', pageIndex)
    },
    [managementAssetWarehouseStore]
  )

const assetTypeNames = assetStatisticList?.assetTypeNames || []
const tableColumns = [
    {
      title: <span className="custom-header">STT</span>,
      width: '30px',
      render: (id, record, index) => (
        <span>{index + 1}</span>
      ),
      align: 'center',
      fixed: 'left',
      ellipsis: true,
    },
    {
      title: <span className="custom-header">Tên đơn vị</span>,
      width: '200px',
      render: record => (
        <span>{record.departmentName}</span>
      ),
      align: 'center',
      fixed: 'left',
      ellipsis: true,
    },
    ...assetTypeNames.map(type => ({
      title: <span className="custom-header">{type}</span>,
      width: '70px',
      render: record => {
        const asset = record.assetTypeList.find(asset => asset.name === type)
        return <span>{asset && typeof asset.quantity === 'number' ? asset.quantity.toLocaleString('vi-VN') : '----'}</span>
      },
      align: 'center',
      ellipsis: true,
    })),
    {
      title: <span className="custom-header">Tổng thuế trước</span>,
      width: '110px',
      render: record => (
        <span>{record.preTax.toLocaleString('vi-VN')}</span>
      ),
      align: 'center',
      fixed: 'right',
      ellipsis: true,
    },
    {
      title: <span className="custom-header">Tổng thuế sau</span>,
      width: '110px',
      render: record => (
        <span>{record.afterTax.toLocaleString('vi-VN')}</span>
      ),
      align: 'center',
      fixed: 'right',
      ellipsis: true,
    },
  ]

  return (
    <>
    <div style={{ overflowX: 'auto' }}>
    <Table
        scroll={{ x: 'max-content' }}
        bordered
        // @ts-ignore
        dataSource={assetStatisticList?.statisticsResponses || []}
        // @ts-ignore
        columns={tableColumns}
        rowClassName={(record, index) => (index % 2 === 0 ? 'row-white' : 'row-blue')}
        pagination={false}
        locale={{
          emptyText: (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={'Không có dữ liệu'}
            />
          ),
        }}
        loading={isLoading}
      />
    </div>
      <TableBottomPaginationBlock>
        <Pagination
          current={pageIndex + 1}
          pageSize={sizeIndex}
          total={totalCount}
          showSizeChanger={false}
          onChange={handleChangePage}
        />
      </TableBottomPaginationBlock>
    </>
  )
}

export default inject('managementAssetWarehouseStore')(
  observer(ExportDistributeVoteTable)
)
